<!--
 * @Author: rossdong rossdong@yntengyun.com
 * @Date: 2026-03-18
 * @LastEditors: rossdong rossdong@yntengyun.com
 * @LastEditTime: 2026-04-24 14:00:38
 * @FilePath: /Gov-Web/Mobile/src/pages/complaint/views/visual/disposalAnalysis/comps/Complete24HoursCountCell.vue
 * @Description: 处置情况分析-24小时办结率
 *
-->
<template>
  <div class="w-full flex flex-col">
    <div class="w-full flex items-end justify-between my-16">
      <div class="text-16 font-bold text-black-primary">24小时办结率</div>
      <div class="flex items-center" @click="ruleDialogShow = true">
        <img src="@/assets/complaint/ic_info_tips.png" alt="" class="size-14 mr-3">
        <span>统计说明</span>
      </div>
    </div>

    <div class="card" v-if="!tableMode">
      <div class="card-head">
        <div class="unit-text">单位（%）</div>
        <div class="assess-wrap">
          <span class="assess-label">按考核规则统计</span>
          <van-switch v-model="assessSwitch" size="28" active-color="#3A7FF0" />
        </div>
      </div>

      <div v-if="loading" class="state-text">加载中...</div>
      <template v-else>
        <div v-if="!list.length" class="state-text">暂无数据</div>
        <div v-else ref="chartEl" class="chart"></div>

        <div class="w-full flex justify-center">
          <div class="avg-tag">平均值：{{ avgRatio || "-" }}</div>
        </div>
      </template>

    </div>

    <div v-else class="card flex flex-col px-10 pt-10 pb-20">
      <o-table :columns="tableColumns" :data="tableData" :height="330" />
    </div>

    <div class="w-full flex justify-center items-center mb-13" @click="tableMode = !tableMode">
      <img src="@/assets/complaint/ic_exchange.png" class="size-12 mr-4">
      <span v-if="tableMode" class="text-[#229F60]">切换为图表</span>
      <span v-else class="text-[#229F60]">切换为表格</span>
    </div>

    <TipsDialog v-model="ruleDialogShow" title="统计说明" :content="ruleText" confirmButtonText="关闭" />
  </div>
</template>

<script>
import echarts from "echarts";
import APIS from "@/service/modules/complaintApis/modules/visualization.js";
import { Table } from "@/components/Table";
import TipsDialog from "../../comps/TipsDialog.vue";
import visualFilterMixin from "../../mixins/visualFilterMixin";

function parsePercent(value) {
  if (value === undefined || value === null || value === "") return 0;
  const text = String(value).trim();
  const n = Number.parseFloat(text.endsWith("%") ? text.slice(0, -1) : text);
  return Number.isFinite(n) ? n : 0;
}

export default {
  name: "Complete24HoursCountCell",
  mixins: [visualFilterMixin],
  components: {
    "o-table": Table,
    TipsDialog,
  },
  props: {
    county: { type: String, default: "" }
  },
  data() {
    return {
      chart: null,
      _onResize: null,

      loading: false,
      tableMode: false,
      assessSwitch: true,
      ruleDialogShow: false,

      total: 0,
      overTotal: 0,
      overAvgRatio: "",
      avgRatio: "",
      list: [],
      tableColumns: [
        { title: "排序", dataProp: "sort", minWidth: '60px', fixed: "left" },
        { title: "区域", dataProp: "cityName", minWidth: "110px", fixed: "left" },
        {
          title: "总量", dataProp: "total", minWidth: "70px",
          renderCell: (h, { rowData }) => h('span', rowData.total + '件')
        },
        {
          title: "已办结投诉量", dataProp: "normalTotal", minWidth: "110px",
          renderCell: (h, { rowData }) => h('span', rowData.normalTotal + '件')
        },
        {
          title: "超时办结量", dataProp: "overTotal", minWidth: "90px",
          renderCell: (h, { rowData }) => h('span', rowData.overTotal + '件')
        },
        { title: "办结率", dataProp: "ratio", minWidth: "90px" }
      ],
      ruleText:
        `默认统计规则
1.仅统计“已办结”的投诉件，不含“处理中、游客撤销、不予受理、退回12345”的投诉件；
2.因存在拆单到不同区域的投诉件，统计时存在以下情形：
（1）总计投诉量≤各区域投诉量之和。例子：投诉件拆单到官渡区、五华区，则列表中各区县投诉件之和为2，总计数据需查询昆明市投诉量，仅1件。
（2）总计超时量≤列表中各区域超时量之和。例子：昆明市有1件投诉件，总时长为25小时，拆单到官渡区、五华区，列表中官渡区、五华区超时件各计1件。查询昆明市总计超时量时，仅计1件，但列表中超时量之和为2。
（3）本辖区区域时长未超时，但其他辖区超时，导致本辖区存在总时长超过24小时的件。例子：投诉件总时长25小时，拆单到官渡区（区域时长23小时）、五华区（区域时长5小时），因总时长超过24小时，官渡区、五华区都需要计1件超时。

按考核规则统计
1.仅统计“已办结”的投诉件，不含“处理中、游客撤销、不予受理、退回12345”的投诉件；
2.仅支持统计2022年1月12日以后的数据。
3.因存在拆单到不同区域的投诉件，统计时存在以下情形：
（1）总计投诉量≤各区域投诉量之和。例子：投诉件拆单到官渡区、五华区，则列表中各区县投诉件之和为2，总计数据需查询昆明市投诉量，仅1件。
（2）总计超时量可能≠各区域超时量之和。例子：投诉件在昆明市用时25小时，拆单到官渡区（20小时）、五华区（5小时）。查询昆明市总计超时量时，各区县超时量之和为0，昆明市超时量为1。`
    };
  },
  computed: {
    tableData() {
      return (this.list || []).map((item, idx) => ({
        ...item,
        sort: idx + 1
      }));
    }
  },
  watch: {
    assessSwitch() {
      this.onLoad();
    },
    list: {
      deep: true,
      handler() {
        this.$nextTick(() => this.renderChart());
      }
    },
    tableMode(val) {
      if (val) {
        this.disposeChart();
        return;
      }
      this.$nextTick(() => {
        this.ensureChart();
        this.renderChart();
      });
    }
  },
  methods: {
    ensureChart() {
      const el = this.$refs.chartEl;
      if (!el) return;
      if (this.chart) {
        if (typeof this.chart.getDom === "function" && this.chart.getDom() !== el) {
          this.disposeChart();
        } else {
          return;
        }
      }
      this.chart = echarts.init(el);
      this._onResize = () => {
        if (this.chart) this.chart.resize();
      };
      window.addEventListener("resize", this._onResize, { passive: true });
    },
    disposeChart() {
      if (this._onResize) {
        window.removeEventListener("resize", this._onResize);
        this._onResize = null;
      }
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
    },
    buildOption() {
      const names = (this.list || []).map(item => item.cityName || "-");
      const values = (this.list || []).map(item => parsePercent(item.ratio));
      const total = names.length;
      const windowSize = 5;
      const startValue = 0;
      const endValue = total > 0 ? Math.min(windowSize - 1, total - 1) : 0;

      return {
        grid: {
          left: 40,
          right: 10,
          top: 20,
          bottom: 40,
          containLabel: false
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          formatter: (params) => {
            const row = params && params[0] ? params[0] : null;
            if (!row) return "";
            const idx = row.dataIndex;
            const item = this.list[idx] || {};
            return `${item.cityName || "-"}<br/>办结率：${item.ratio || "0%"}`;
          }
        },
        dataZoom: [
          {
            type: "inside",
            xAxisIndex: 0,
            zoomLock: true,
            startValue,
            endValue,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
            zoomOnMouseWheel: false
          }
        ],
        xAxis: {
          type: "category",
          data: names,
          axisTick: { show: false },
          axisLine: { lineStyle: { color: "#d9d9d9" } },
          axisLabel: {
            color: "#333",
            fontSize: 12,
            margin: 10,
            interval: 0
          }
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100,
          splitNumber: 5,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: "#999",
            fontSize: 12,
            formatter: (val) => (val === 0 ? "0" : `${val}%`)
          },
          splitLine: { lineStyle: { color: "#e5e5e5", type: "solid" } }
        },
        series: [
          {
            type: "bar",
            data: values,
            barWidth: 15,
            barCategoryGap: "70%",
            itemStyle: {
              color: "#36B374",
              borderRadius: [8, 8, 0, 0]
            }
          }
        ]
      };
    },
    renderChart() {
      if (this.loading || !this.list.length) return;
      this.$nextTick(() => {
        this.ensureChart();
        if (!this.chart) return;
        this.chart.setOption(this.buildOption(), true);
        this.chart.resize();
      });
    },
    onLoad() {
      const { areaId, beginTime, endTime, rule, channel } = this.filterParams;
      const params = {
        cityId: areaId,
        county: this.county,
        startDate: beginTime,
        endDate: endTime,
        rule: rule,
        channel: channel,
        assess: this.assessSwitch ? 1 : 0
      };

      this.loading = true;
      return APIS.complete24Rate(params).then((res) => {
        if (!res || res.ret !== 0) {
          this.total = 0;
          this.overTotal = 0;
          this.overAvgRatio = "";
          this.avgRatio = "";
          this.list = [];
          return;
        }
        const data = res.data || {};
        this.total = Number(data.total || 0);
        this.overTotal = Number(data.overTotal || 0);
        this.overAvgRatio = data.overAvgRatio || "";
        this.avgRatio = data.avgRatio || "";
        this.list = Array.isArray(data.list) ? data.list : [];
      }).finally(() => {
        this.loading = false;
        this.$nextTick(() => this.renderChart());
      });
    }
  },
  mounted() {
    this.ensureChart();
  },
  beforeDestroy() {
    this.disposeChart();
  }
};
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 13px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
  padding: 12px;
}

.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.unit-text {
  font-size: 14px;
  line-height: 20px;
  color: #999;
}

.assess-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.assess-label {
  font-size: 14px;
  line-height: 20px;
  color: #1E2226;
}

.chart {
  height: 320px;
  width: 100%;
}

.state-text {
  width: 100%;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
}

.avg-tag {
  margin: 8px auto 2px;
  padding: 8px 22px;
  border-radius: 6px;
  background: rgba(58, 127, 240, 0.18);
  color: #2f63c7;
  font-size: 12px;
  font-weight: 400;
  width: auto;
}
</style>
